module.exports = __webpack_public_path__ + "img/p2_bg_2.641ec6c2.jpg";